module.exports = __webpack_public_path__ + "media/easyload-xl.f6db08c3.webm";